import { FC } from 'react'
import { TableSkeleton } from '../../../__legacy__/components/platform/new-explore/components/Table'
import TableRow, {
  TableRowHeader
} from '../../../__legacy__/components/platform/new-explore/components/TableRow'
import Tabs from '../../../__legacy__/components/platform/new-explore/components/Tabs'
import useSelectedMedia from '../../../__legacy__/components/platform/new-explore/hooks/useSelectedMedia'
import { IArpMedia } from '../../arp-registry/ArpMedia'
import { CurrentPageContext } from '../../verified-media'
import { useCSSGradient } from '../hooks'
import { useArpVerifiedRemixes } from '../hooks/useArpVerifiedRemixes'
import { Section } from '../primitives'

export const ArpVerifiedTabContent: FC<{ media: IArpMedia }> = ({ media }) => {
  const { data, status, orderBy, order, handleOrderChange } = useArpVerifiedRemixes(media)
  const { index, handleSelect } = useSelectedMedia({ queueData: data.map((e) => e.id) })

  const { color } = useCSSGradient(media)
  return (
    <CurrentPageContext.Provider value={{ arpMediaId: media.id }}>
      <Tabs.Content value="#verified">
        <Section.Root>
          <Section.Flare1 css={{ color }} />
          <Section.Flare2 css={{ color }} />
          <Section.Content>
            <TableRowHeader order={order} orderBy={orderBy} used onSelect={handleOrderChange} />
            {status !== 'ready' && <TableSkeleton size={8} />}
            {data.map((m) => (
              <TableRow
                media={m}
                key={m.id}
                onSelect={handleSelect}
                active={m.id === index}
                used={true}
              />
            ))}
          </Section.Content>
        </Section.Root>
      </Tabs.Content>
    </CurrentPageContext.Provider>
  )
}
